export default "__VITE_ASSET__GL94o0mR__"